import { config } from 'config/constants';
import { IAppReducer } from 'models';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export const SubscriptionEdit = () => {
  const { subId, subVersion } = useParams();
  const { authReducer: user } = useSelector((state: IAppReducer) => state);

  if (!subId || !subVersion) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Error: Parámetros de suscripción inválidos</p>
      </div>
    );
  }

  const authId = user.uid;
  const companyId = user.companyId;
  const jwt = user.accessToken;
  const agentAuthId = user.agentAuthData ? user.agentAuthData.uid : '';

  const iframeUrl = `${
    config.soda.sodaUrl
  }/subscriptions/${subId}/edit?authId=${encodeURIComponent(
    authId
  )}&token=${encodeURIComponent(
    jwt
  )}&agentAuthId=${agentAuthId}&subId=${subId}&subVersion=${subVersion}&companyId=${companyId}`;

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        title="Editar suscripción"
        style={{ border: 'none' }}
      />
    </div>
  );
};
